import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const Hero1SectionImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_568', width: 568, height: 284, ratio: 2 },
  { screen: Screen.XS, key: '2_1_768', width: 768, height: 384, ratio: 2 },
  { screen: Screen.SM, key: '2_1_1024', width: 1024, height: 512, ratio: 2 },
  { screen: Screen.MD, key: '2_1_1366', width: 1366, height: 683, ratio: 2 },
  { screen: Screen.LG, key: '8_3_1600', width: 1600, height: 600, ratio: 2.66 },
  { screen: Screen.XL, key: '8_3_1800', width: 1800, height: 675, ratio: 2.66 },
];
